import { ethers } from "ethers";

export const MAX_ALLOWANCE = ethers.BigNumber.from(
  "3402823669209384634633746074310"
);

export const balanceBundlerMainnet =
  "0xb1f8e55c7f64d203c1400b9d8555d050f94adf39";
export const balanceBundlerAddress =
  "0x1b7ad12c73b9fea574cd2320650676c0a0bde8a0";
